/**
 * Public katalog o'qish kontraktlari (Faza 2) — buyer browse.
 *
 * marketplace-api shu shakl bilan list/detail qaytaradi; buyer PWA mock o'rniga
 * shu DTO'larni iste'mol qiladi. ⚠️ Public — tenant ichki ma'lumoti (storeId,
 * cost, internal) OSHKOR ETILMAYDI (FORCE RLS bleed-through himoyasi):
 * faqat denormalizatsiya qilingan public maydonlar.
 */
import { z } from 'zod';
export const catalogSortValues = ['popular', 'cheap', 'expensive', 'rating', 'new'];
// ─── List query (filter + sort + pagination) ──────────────────────
export const catalogListQuerySchema = z.object({
    q: z.string().trim().max(120).optional(),
    category: z.string().trim().max(120).optional(),
    brand: z.string().trim().max(120).optional(),
    partType: z.string().trim().max(80).optional(), // detal turi (AI) — o'xshash mahsulotlar
    excludeId: z.string().trim().max(60).optional(), // joriy mahsulotni chiqarib tashlash
    sort: z.enum(catalogSortValues).default('popular'),
    minPrice: z.coerce.number().nonnegative().optional(),
    maxPrice: z.coerce.number().positive().optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(60).default(24),
});
//# sourceMappingURL=catalog.schema.js.map